<template>
    <div>
        <Row :gutter="16">

            <Layout>
                <Content style="min-width:500px;margin:0 8px">
                    <Card>
                        <p slot="title">{{t.routerName}}</p>
                        <Row>
                            <Col>
                                <Form :model="formItem" :rules="ruleValidate" :label-width="85" label-position="right"
                                      ref="form">
                                    <FormItem :label="t.user.name" prop="name">
                                        <Input v-model="formItem.name"
                                               :placeholder="msgUtil.placeholderRequired(t.user.name)"></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.email" prop="email">
                                        <Input v-model="formItem.email"
                                               :placeholder="msgUtil.placeholderRequired(t.user.email)"></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.mobile" prop="mobile">
                                        <Input v-model="formItem.mobile"
                                               :placeholder="msgUtil.placeholderRequired(t.user.mobile)"></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.sex" prop="sex">
                                        <i-switch v-model="formItem.sex" size="large" true-value="0" false-value="1">
                                            <span slot="open">{{t.user.male}}</span>
                                            <span slot="close">{{t.user.female}}</span>
                                        </i-switch>
                                    </FormItem>
                                    <FormItem :label="t.user.remark" prop="remark">
                                        <Input v-model="formItem.remark"
                                               :autosize="{minRows: 16,maxRows: 16}"
                                               :placeholder="msgUtil.placeholderRequired(t.user.remark)"
                                               type="textarea"></Input>
                                    </FormItem>
                                    <FormItem>
                                        <Button type="primary" :loading="loading" @click="handleSubmit">
                                            {{msgUtil.message.action.submit}}
                                        </Button>
                                        <Button style="margin-left: 8px" type="warning" @click="changePassword">
                                            {{msgUtil.message.action.changePwd}}
                                        </Button>
                                    </FormItem>
                                </Form>
                            </Col>
                        </Row>
                    </Card>
                </Content>
                <Sider hide-trigger width="400" style="background:transparent;margin:0 8px">
                    <Row>
                        <Card>
                            <div class="img-drag" @click="changeCropper">
                                <img :src="formItem.avatar" class="upload_img"/>
                            </div>
                        </Card>
                    </Row>
                    <Row class="margin-top-10">
                        <Card style="font-size: 12px;">
                            <p slot="title">
                                <Icon type="logo-buffer"/>
                                {{t.base.info}}
                            </p>
                            <Row class="margin-bottom-10" type="flex" align="middle">
                                <Col span="4" offset="2">{{t.user.deptName}}</Col>
                                <Col span="18">
                                    <Tag type="border">{{ formItem.deptName }}</Tag>
                                </Col>
                            </Row>
                            <Row class="margin-bottom-10" type="flex" align="middle">
                                <Col span="4" offset="2">{{t.user.loginName}}</Col>
                                <Col span="18">
                                    <Tag type="border">{{ formItem.loginName }}</Tag>
                                </Col>
                            </Row>
                            <Row class="margin-bottom-10" type="flex" align="middle">
                                <Col span="4" offset="2">{{t.user.type}}</Col>
                                <Col span="18">
                                    <Tag type="border">{{ formItem.type }}</Tag>
                                </Col>
                            </Row>
                            <Row class="margin-bottom-10" type="flex" align="middle">
                                <Col span="4" offset="2">{{t.user.status}}</Col>
                                <Col span="18">
                                    <Tag type="border">{{ formItem.status }}</Tag>
                                </Col>
                            </Row>
                            <Row class="margin-bottom-10" type="flex" align="middle">
                                <Col span="4" offset="2">{{t.user.postName}}</Col>
                                <Col span="18">
                                <span v-for="item in postList" :value="item.id" :key="item.id">
                                    <Tag type="border">{{ item.name }}</Tag>
                                </span>
                                </Col>
                            </Row>
                            <Row type="flex" align="middle" style="margin-bottom:30px;">
                                <Col span="4" offset="2">{{t.user.roleName}}</Col>
                                <Col span="18">
                                <span v-for="item in roleList" :value="item.id" :key="item.id">
                                    <Tag type="border">{{ item.name }}</Tag>
                                </span>
                                </Col>
                            </Row>
                        </Card>
                    </Row>
                </Sider>
            </Layout>
        </Row>
        <Modal
            :title='msgUtil.message.action.changePic'
            v-model="modalManage.avatarModal"
            :mask="true"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="resetCropperModal">
            <Row>
                <div class="content">
                    <div class="sub-cropper">
                        <vueCropper
                            ref="cropper"
                            :img="option.img"
                            :outputSize="option.outputSize"
                            :outputType="option.outputType"
                            :info="option.info"
                            :full="option.full"
                            :canMove="option.canMove"
                            :canMoveBox="option.canMoveBox"
                            :fixedBox="option.fixedBox"
                            :original="option.original"
                            :autoCrop="option.autoCrop"
                            :autoCropWidth="option.autoCropWidth"
                            :autoCropHeight="option.autoCropHeight"
                            :centerBox="option.centerBox"
                            :high="option.high"
                            :infoTrue="option.infoTrue"
                            @realTime="realTime"
                            @imgLoad="imgLoad"
                            @cropMoving="cropMoving"
                            :enlarge="option.enlarge"
                        ></vueCropper>
                    </div>
                </div>
            </Row>
            <Row>
                <Col style="text-align:right;">
                    <Upload action="image/jpeg" :before-upload="handleBeforeUpload"
                            style="display:inline-block;margin-right: 10px;">
                        <Button icon="ios-cloud-upload-outline">
                            {{msgUtil.message.action.picSelect}}
                        </Button>
                    </Upload>
                    <Button v-if="option.img != null && option.img !== ''" type="primary" @click="handleUpload">
                        {{msgUtil.message.action.upload}}
                    </Button>
                    <Button v-else type="primary" disabled>
                        {{msgUtil.message.action.upload}}
                    </Button>
                </Col>
            </Row>
        </Modal>
        <Modal
            :title='msgUtil.message.action.changePwd'
            v-model="modalManage.passwordModal"
            :mask="true"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="resetPasswordModal">
            <Row>
                <Form :model="formItem" :rules="pwdRuleValidate" ref="form2">
                    <FormItem :label="t.user.password" prop="password">
                        <Input v-model="formItem.password" type="password" :maxlength="25"
                               :placeholder="msgUtil.placeholderRequired(t.user.password)"></Input>
                    </FormItem>
                    <FormItem :label="t.user.newPassword" prop="newPassword">
                        <Input v-model="formItem.newPassword" type="password" :maxlength="25"
                               :placeholder="msgUtil.placeholderRequired(t.user.newPassword)"></Input>
                    </FormItem>
                    <FormItem :label="t.user.newPasswordConfirm" prop="newPasswordConfirm">
                        <Input v-model="formItem.newPasswordConfirm" type="password" :maxlength="25"
                               :placeholder="msgUtil.placeholderRequired(t.user.newPasswordConfirm)"></Input>
                    </FormItem>
                </Form>
            </Row>
            <Row style="margin-top:5px;">
                <Col style="text-align:right;">
                    <Button type="primary" @click="handleSubmitPassword">
                        {{msgUtil.message.action.submit}}
                    </Button>
                </Col>
            </Row>
        </Modal>
    </div>
</template>
<script>
import BaseUrl from '_conf/url';
import { VueCropper } from 'vue-cropper';
import CryptoJS from 'crypto-js';
import store from '@/store';
import { cpassword, getUserInfo, putMyInfo } from '@/api/user';
import { getDeptInfo } from '@/api/dept';
import { getPostList } from '@/api/post';
import { getRoleList } from '@/api/role';
import { uploadImg } from '@/api/image';
import Vue from 'vue';

export default {
    name: 'myInfo',
    components: {
        VueCropper,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            baseURL: BaseUrl.dataUrl + 'images/sm/',
            option: {
                img: '',
                outputSize: 1,
                //输出图片格式
                outputType: 'png',
                info: true,
                //截图信息展示是否是真实的输出宽高
                infoTrue: true,
                //是否输出原图比例的截图
                full: false,
                //能否拖动图片
                canMove: true,
                //能否拖动截图框
                canMoveBox: true,
                //截图框固定大小
                fixedBox: true,
                //上传图片是否显示原始宽高 (针对大图 可以铺满)
                original: false,
                //是否自动生成截图框
                autoCrop: true,
                // 只有自动截图开启 宽度高度才生效
                autoCropWidth: 360,
                autoCropHeight: 360,
                //截图框是否限制在图片里(只有在自动生成截图框时才能生效)
                centerBox: false,
                //是否根据dpr生成适合屏幕的高清图片
                high: true,
                //是否按照截图框比例输出 默认为1
                enlarge: 1,
                cropData: {},
            },
            formItem: {
                deptId: '',
                deptName: '',
                avatar: '',
                loginName: '',
                password: '',
                newPassword: '',
                newPasswordConfirm: '',
                name: '',
                email: '',
                mobile: '',
                sex: '0',
                status: '1',
                type: '0',
                remark: '',
                postIdList: [],
                roleIdList: [],
            },
            postList: [],
            roleList: [],
            correlateObject: {
                status: '1',
                size: '99999',
            },
            modalManage: {
                avatarModal: false,
                passwordModal: false,
            },
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.name),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 64,
                        message: msgUtil.errorMaxLengthFullWidth(t.user.name, 64),
                        trigger: 'blur',
                    },
                ],
                mobile: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.mobile),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[0-9]*$/,
                        message: msgUtil.errorRequiredHalfWidthNumber(t.user.mobile),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 15,
                        message: msgUtil.errorMaxLength(t.user.mobile, 15),
                        trigger: 'blur',
                    },
                ],
                email: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.email),
                        trigger: 'blur',
                    },
                    {
                        type: 'email',
                        message: msgUtil.errorFormat(t.user.email),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLength(t.user.email, 100),
                        trigger: 'blur',
                    },
                ],
                remark: [
                    {
                        type: 'string',
                        max: 500,
                        message: msgUtil.errorMaxLengthFullWidth(t.user.remark, 500),
                        trigger: 'blur',
                    },
                ],
            },
            pwdRuleValidate: {
                password: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.password),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[a-zA-Z0-9]+$/,
                        message: msgUtil.placeholderRequiredHalfWidthCharOrNumber(t.user.password),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 25,
                        message: msgUtil.errorMaxLength(t.user.password, 25),
                        trigger: 'blur',
                    },
                ],
                newPassword: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.newPassword),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[a-zA-Z0-9]+$/,
                        message: msgUtil.placeholderRequiredHalfWidthCharOrNumber(t.user.newPassword),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 25,
                        message: msgUtil.errorMaxLength(t.user.newPassword, 25),
                        trigger: 'blur',
                    },
                ],
                newPasswordConfirm: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.newPasswordConfirm),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[a-zA-Z0-9]+$/,
                        message: msgUtil.placeholderRequiredHalfWidthCharOrNumber(t.user.newPasswordConfirm),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 25,
                        message: msgUtil.errorMaxLength(t.user.newPasswordConfirm, 25),
                        trigger: 'blur',
                    },
                ],
            },
            loading: false,
        };
    },
    methods: {
        async handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    let userDto = {};
                    userDto.avatar = this.formItem.avatar;
                    userDto.email = this.formItem.email;
                    userDto.mobile = this.formItem.mobile;
                    userDto.name = this.formItem.name;
                    userDto.sex = this.formItem.sex;
                    userDto.remark = this.formItem.remark;
                    // const res = await putMyInfo(this.$store.state.user.myInfo.id, userDto);
                    await putMyInfo(userDto);
                    // 更新全局个人情报
                    this.$store.commit('user/setMyInfo', Object.assign({}, this.formItem));
                    this.$Loading.finish();
                    this.$Message.success(this.msgUtil.message.action.updateSuccess);
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.message.action.updateFail);
                }
            });
            this.loading = false;
        },
        changePassword() {
            this.modalManage.passwordModal = true;
        },
        resetPasswordModal() {
            //this.$refs.form.resetFields();
            this.$refs.form2.resetFields();
            // this.$Loading.finish();
        },
        handleSubmitPassword() {
            this.loading = true;
            this.$Loading.start();
            this.$refs['form2'].validate(async valid => {
                if (valid) {
                    let userPasswordDto = {};
                    userPasswordDto.password = CryptoJS.MD5(this.formItem.password + store.state.user.myInfo.salt)
                        .toString()
                        .toUpperCase();
                    userPasswordDto.newPassword = CryptoJS.MD5(this.formItem.newPassword + store.state.user.myInfo.salt)
                        .toString()
                        .toUpperCase();
                    userPasswordDto.newPasswordConfirm = CryptoJS.MD5(
                        this.formItem.newPasswordConfirm + store.state.user.myInfo.salt
                    )
                        .toString()
                        .toUpperCase();
                    await cpassword(userPasswordDto);
                    this.modalManage.passwordModal = false;
                    this.resetPasswordModal();
                    this.$Message.success(this.msgUtil.actionModuleUpdateSuccess(this.t.user.pwd));
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.actionModuleUpdateFail(this.t.user.pwd));
                }
            });
            this.loading = false;
        },
        //随机数
        getRandomString(len) {
            len = len || 32;
            const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; // 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
            const maxPos = $chars.length;
            let pwd = '';
            for (let i = 0; i < len; i++) {
                pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
            }
            return pwd;
        },
        async handlePwdRandom() {
            // this.formItem.newPassword  = await this.getRandomString(6);
            let pass = await this.getRandomString(6);
            Vue.set(this.formItem, 'newPassword', pass);
        },
        changeCropper() {
            this.option.img = this.formItem.avatar;
            this.modalManage.avatarModal = true;
        },
        resetCropperModal() {
            // this.$Loading.finish();
        },
        // 实时预览函数
        realTime(data) {
            let previews = data;
            let h = 0.5;
            let w = 0.2;
            this.previewStyle1 = {
                width: previews.w + 'px',
                height: previews.h + 'px',
                overflow: 'hidden',
                margin: '0',
                zoom: h,
            };
        },
        handleBeforeUpload(file) {
            //上传图片
            if (!/^image/.test(file.type) || !/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
                this.$Notice.warning({
                    title: this.msgUtil.message.file.error.format,
                    desc:
                        this.msgUtil.message.file.name +
                        '{' +
                        file.name +
                        '}' +
                        this.msgUtil.message.file.error.typeFormat,
                    duration: 15,
                });
                return false;
            }

            let reader = new FileReader();
            reader.onload = e => {
                let data;
                //console.log(e);
                if (typeof e.target.result === 'object') {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                    data = e.target.result;
                }
                this.option.img = data;
            };

            // 转化为base64
            // reader.readAsDataURL(file)
            // 转化为blob
            reader.readAsArrayBuffer(file);
            return false;
        },
        handleUpload() {
            this.$refs.cropper.getCropBlob(data => {
                //var blobObject = new Blob([data]);
                const formData = new FormData();
                formData.append('image', data);
                uploadImg(formData).then(d => {
                    this.formItem.avatar = BaseUrl.Url + d.url;
                    this.modalManage.avatarModal = false;
                });
            });
        },
        imgLoad(msg) {
            //console.log(msg);
        },
        cropMoving(data) {
            this.option.cropData = data;
        },
        async init() {
            //得到所有岗位
            const posts = await getPostList(this.correlateObject);
            //得到所有角色
            const roles = await getRoleList(this.correlateObject);
            const userInfo = await getUserInfo(this.$store.state.user.myInfo.id);
            // const userInfo = await getUserInfo(this.$route.params.id);
            if (userInfo.user != null) {
                this.formItem = userInfo.user;
                //用户类型设定
                if (this.formItem.type === '2') {
                    this.formItem.type = this.t.user.systemUser;
                } else if (this.formItem.type === '1') {
                    this.formItem.type = this.t.user.members;
                } else {
                    this.formItem.type = this.t.user.normalUser;
                }
                //用户状态设定
                if (this.formItem.status === '1') {
                    this.formItem.status = this.t.user.open;
                } else {
                    this.formItem.status = this.t.user.close;
                }
                if (this.formItem.postIdList.length > 0) {
                    if (posts.page != null) {
                        for (let index = 0; index < posts.page.records.length; index++) {
                            let p = posts.page.records[index];
                            if (this.formItem.postIdList.includes(p.id)) {
                                this.postList.push({ id: p.id, name: p.name });
                            }
                        }
                    }
                }

                if (this.formItem.roleIdList.length > 0) {
                    if (roles.page != null) {
                        for (let index = 0; index < roles.page.records.length; index++) {
                            let r = roles.page.records[index];
                            if (this.formItem.roleIdList.includes(r.id)) {
                                this.roleList.push({ id: r.id, name: r.name });
                            }
                        }
                    }
                }
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" scoped>
.img-drag {
    background: #fff;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s ease;
    width: 362px;
    height: 362px;
    &:hover {
        border: 1px dashed #2d8cf0;
    }
    img {
        width: 100%;
        vertical-align: middle;
    }
}

.content {
    max-width: 800px;
    margin-bottom: 10px;
}

.sub-cropper {
    height: 400px;
}

@keyframes slide {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 1000px) {
    .content {
        max-width: 100%;
        /* margin: auto;*/
    }

    .sub-cropper {
        height: 400px;
    }
}
</style>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
